import { FiCamera, FiEdit2, FiFileText, FiList, FiUser, FiX } from "react-icons/fi";
import { Link } from "react-router-dom";
import { useState } from "react";

export default function CourseList({
  id,
  title,
  mentor = [],
  imgSrc,
  editLink,
  onChangeCover = () => {},
  onChangePdf = () => {},
  onAddMentor = () => {},
  onDeleteMentor = () => {},
}) {
  const [hover, setHover] = useState(false);
  return (
    <div
      className={`border border-white-200 rounded-sm p-3 lg:p-4 flex items-center gap-4 mt-4 transition-colors ${
        hover ? "bg-white-200 border-white-300" : "bg-white-100"
      }`}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <img
        src={
          imgSrc && imgSrc !== "null"
            ? process.env.REACT_APP_BASE_URL + imgSrc
            : `${process.env.REACT_APP_BASE_URL}/no-image.png`
        }
        alt={"Cover " + title}
        className="w-20 lg:w-24 h-20 lg:h-24 object-cover rounded bg-white-200"
        onError={(e) => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = `${process.env.REACT_APP_BASE_URL}/no-image.png`;
        }}
      />
      <div className="flex-1 min-w-0">
        <h3 className="font-bold text-base md:text-lg">{title}</h3>
        {mentor.length ? (
          <div className="flex flex-wrap mt-1">
            {mentor.map((item, index) => (
              <div
                key={`${index}`}
                className="text-sm bg-white-200 px-2 flex mb-2 mr-2 h-8 items-center rounded"
              >
                <span className="truncate max-w-xs">{item.fullname}</span>
                <button
                  className="w-5 h-5 bg-red-100 hover:bg-red-200 text-white-100 flex justify-center items-center rounded ml-2"
                  type="button"
                  onClick={() => onDeleteMentor(item.id)}
                >
                  <FiX />
                </button>
              </div>
            ))}
          </div>
        ) : (
          <div className="mt-1 text-sm mb-2 mr-2 h-8">Belum Ada Mentor</div>
        )}
      </div>
      <div className="flex items-center flex-wrap gap-2">
        <button
          onClick={() => {
            onChangeCover();
          }}
          type="button"
          className="p-1.5 rounded-sm border border-white-300 text-sm transition-colors hover:bg-primary-400 hover:border-primary-500 hover:text-white-100 flex items-center"
        >
          <FiCamera />
        </button>
        <button
          onClick={() => {
            onChangePdf();
          }}
          type="button"
          title="Ganti PDF"
          className="p-1.5 rounded-sm border border-white-300 text-sm transition-colors hover:bg-primary-400 hover:border-primary-500 hover:text-white-100 flex items-center"
        >
          <FiFileText />
        </button>
        <button
          onClick={() => {
            onAddMentor();
          }}
          type="button"
          className="p-1.5 rounded-sm border border-white-300 text-sm transition-colors hover:bg-primary-400 hover:border-primary-500 hover:text-white-100 flex items-center"
        >
          <FiUser />
        </button>
        {editLink ? (
          <Link
            to={editLink}
            className="p-1.5 rounded-sm border border-white-300 text-sm transition-colors hover:bg-yellow-200 hover:border-yellow-300 flex items-center"
          >
            <FiEdit2 />
          </Link>
        ) : null}
        <Link
          to={`/course/${id}/subject`}
          className="p-1.5 rounded-sm border border-white-300 text-sm transition-colors hover:bg-primary-400 hover:border-primary-500 hover:text-white-100 flex items-center"
        >
          <FiList />
        </Link>
      </div>
    </div>
  );
}
